import Login from "./../views/Login.vue";

import { routes as administratorRoutes } from "./administrator";
import { routes as functionaryRoutes } from "./functionary";
import { routes as administrativeRoutes } from "./administrative";

export const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "login",
    component: Login,
  },
  ...administratorRoutes,
  ...administrativeRoutes,
  ...functionaryRoutes,
  {
    path:'*',
    redirect:'/'
  }

  
];
